@keyframes Pulse {
  0% {
    opacity: 0.9;
    transform: scale(1);
  }
  5% {
    opacity: 0.9;
  }
  10% {
    opacity: 0.3;
  }
  20% {
    opacity: 0.05;
  }
  40% {
    opacity: 0;
    transform: scale(40);
  }
  100% {
    opacity: 0;
    transform: scale(40);
  }
}

.PrioAnimation {
  position: absolute;

  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in;
}
